<template>
  <div class="ml-2">
    <h3 class="mb-2">Dynamic Watchlists</h3>
    <div class="dynamic-watchlists-container mt-5" v-if="dynamicWatchlists !== null">
      <div v-for="dynamicWatchlist in dynamicWatchlists" :key="dynamicWatchlist.uuid">

        <span class="dynamic-watchlist-container text-left"
              v-on:click="gotoDynamicWatchlist(dynamicWatchlist)">
          {{dynamicWatchlist.name}}
        </span>

        <span v-on:click="deleteDynamicWatchlist(dynamicWatchlist)"> - </span>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '@/assets/js/stockifyApi';
import { TICKER_DYNAMIC_WATCHLIST, TICKER_DYNAMIC_WATCHLISTS } from '@/assets/js/endpoints';

export default {
  name: 'DynamicWatchlists',
  data() {
    return {
      dynamicWatchlists: [],
    };
  },
  methods: {
    getDynamicWatchlists() {
      apiCall({
        url: TICKER_DYNAMIC_WATCHLISTS,
      }).then((response) => {
        this.dynamicWatchlists = response.data;
      });
    },
    gotoDynamicWatchlist(dynamicWatchlist) {
      this.$router.push({ path: `/dynamic-watchlist/${dynamicWatchlist.uuid}` });
    },
    deleteDynamicWatchlist(dynamicWatchlist) {
      apiCall({
        method: 'DELETE',
        url: `${TICKER_DYNAMIC_WATCHLIST}/${dynamicWatchlist.uuid}`,
      }).then(() => {
        this.getDynamicWatchlists();
      });
    },
  },
  mounted() {
    this.getDynamicWatchlists();
  },
};
</script>

<style>
.dynamic-watchlists-container {
  cursor: pointer;
}
</style>
